import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {FileService} from "../../providers/file.service";
import {ModalController} from "@ionic/angular";
import {FilesDetailsPreviewerComponent} from "../files-details-previewer/files-details-previewer.component";
import {VetineoFile} from "../../models/file/vetineo-file.model";
import {environment} from "../../../environments/environment";
import {AppStateService} from "../../providers/app-state.service";

@Component({
  selector: 'app-files-preview',
  templateUrl: './files-preview.component.html',
  styleUrls: ['./files-preview.component.scss'],
})
export class FilesPreviewComponent implements OnInit {

  slideOpts = {
    slidesPerView: 3,
    initialSlide: 3,
    speed: 400,
  };

  @Input()
  private files: VetineoFile[];
  @Input()
  private vetReservationUuid: string;


  constructor(private fileService: FileService,
              private modalController: ModalController, private appStateService: AppStateService) {
  }


  async presentModal(file: string, type: string) {
    const modal = await this.modalController.create({
      component: FilesDetailsPreviewerComponent,
      componentProps: {
        'file': file,
        'type': type
      }
    });
    return await modal.present();
  }

  ngOnInit(): void {
  }

  openFile(file: VetineoFile) {
    this.appStateService.updateIsBusySubject(true);
    this.fileService.getVetReservationFile(file.name, this.vetReservationUuid).subscribe(it => {
      this.presentModal(it.path, it.type).then(e=>{this.appStateService.updateIsBusySubject(false)})
    })
  }
}
